import { Controller, useFormContext } from 'react-hook-form'

import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import { castError } from '../../castError'
import withCustomizationFields, {
  WithCustomizationFieldsProps,
} from '../../withCustomizationFields'
import withFieldPermissions, { WithFieldPermissionsProps } from '../../withFieldPermissions'

const FIELD_NAME = 'merchantTin'

const MerchantTinField = ({
  isFieldMandatory,
  isFieldReadOnly,
}: WithCustomizationFieldsProps & WithFieldPermissionsProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext()

  return (
    <Controller
      control={control}
      name={FIELD_NAME}
      render={({ field }) => (
        <TextField
          label={i18n.t('expenses_v2.forms.fields.vendor_tin.label')}
          mandatory={isFieldMandatory}
          value={field.value ?? ''}
          onChange={(value) => field.onChange(value)}
          placeholder={i18n.t('expenses_v2.forms.fields.vendor_tin.placeholder')}
          error={castError(errors?.merchantTin)}
          readonly={isFieldReadOnly}
        />
      )}
    />
  )
}

export default withCustomizationFields(withFieldPermissions(MerchantTinField, FIELD_NAME))
